import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import api from '../../utils/api';

import { getDriveApiToken } from '../../lib/auth-token';
export interface StorageStats {
  used: number;
  total: number;
  files: number;
  folders: number;
  breakdown?: Record<string, number>;
}

interface StorageState {
  stats: StorageStats | null;
  isLoading: boolean;
  loading: boolean; // For backward compatibility
  error: string | null;
}

const initialState: StorageState = {
  stats: null,
  isLoading: false,
  loading: false,
  error: null,
};

// Helper to configure axios with token
const getAxiosConfig = () => {
  const token = getDriveApiToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// Async actions
export const fetchStorageStats = createAsyncThunk(
  'storage/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/storage/stats', getAxiosConfig());
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch storage stats');
    }
  }
);

const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    clearStorageError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Stats
      .addCase(fetchStorageStats.pending, (state) => {
        state.isLoading = true;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStorageStats.fulfilled, (state, action: PayloadAction<StorageStats>) => {
        state.isLoading = false;
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchStorageStats.rejected, (state, action) => {
        state.isLoading = false;
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearStorageError } = storageSlice.actions;
export default storageSlice.reducer; 